var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "seo-content-block", style: _vm.contentBlockStyles },
    [
      _c(
        "div",
        { staticClass: "seo-content-block__wrapper" },
        [
          _c("seo-content-accordion", {
            attrs: {
              title: _vm.schema.settings.title,
              content: _vm.schema.settings.content
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }